import React, { useEffect, useState } from "react";
import DrawerComponent from "../../../ui/Drawer";
import LabelText from "../../../ui/LabelText";
import { DrawerContainer, DrawerHeader, SearchResults } from "../../../styled-components/Drawer.Styles";
import { ForawrdBackwardButton } from "../../../styled-components/PageHeaderStyles";
import CloseIcon from "@mui/icons-material/Close";
import { CheckboxInput } from "../../../ui/FilterDropdown";
import { styled } from "styled-components";
import PrimaryButton from "../../../ui/PrimaryButton";
import SearchInput from "../../../ui/SearchInput";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface SelectAttributeProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (selectedData: ITag[]) => void;
  selectedTag: ITag[];
}

export interface ITag {
  id: string;
  label: string;
  checked: boolean;
}

const TagsList = styled.div<{ checked: boolean }>`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.playerDataBorder};
  background: ${({ theme, checked }) => (checked ? theme.playerCardBackground : "none")};
  .cta-btn-icons {
    fill: ${({ theme }) => theme.tabTitleColor};
  }
`;

const SearchTag = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.playerDataBorder};
  background: ${({ theme }) => theme.playerContentBackground};
`;

const tags: ITag[] = [
  { id: "Long-shot expert", label: "Long-shot expert", checked: false },
  { id: "Free kick taker", label: "Free kick taker", checked: false },
  { id: "Long throw taker", label: "Long throw taker", checked: false },
  { id: "Corner taker", label: "Corner taker", checked: false },
  { id: "Penalty taker", label: "Penalty taker", checked: false },
  { id: "Consistent performer", label: "Consistent performer", checked: false },
  { id: "Anchor", label: "Anchor", checked: false },
  { id: "Low coheesion", label: "Low coheesion", checked: false },
  { id: "Versatile", label: "Versatile", checked: false },
  { id: "Quick learner", label: "Quick learner", checked: false },
  { id: "Experienced", label: "Experienced", checked: false },
  { id: "Controversial", label: "Controversial", checked: false },
  { id: "Leader", label: "Leader", checked: false },
  { id: "Hot head", label: "Hot head", checked: false },
  { id: "Petulant", label: "Petulant", checked: false },
];

const SelectTags: React.FC<SelectAttributeProps> = ({ isOpen, onClose, onConfirm, selectedTag }) => {
  const [tagsState, setTagsState] = useState<ITag[]>(tags);
  const [clearInput, setClearInput] = useState(false);

  useEffect(() => {
    const initializedTags = tags.map((tag) => ({
      ...tag,
      checked: selectedTag.some((selected) => selected.id === tag.id),
    }));
    setTagsState(initializedTags);
  }, [selectedTag]);

  const handleCheckboxChange = (id: string) => {
    setTagsState((prevTags) => prevTags.map((tag) => (tag.id === id ? { ...tag, checked: !tag.checked } : tag)));
  };

  const handleConfirm = () => {
    const selectedTags = tagsState.filter((tag) => tag.checked);
    onConfirm(selectedTags);
    onClose();
  };

  const anyTagChecked = tagsState.some((tag) => tag.checked);

  const handleClear = () => {};
  const handleSearch = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    setTagsState(tags.filter((tag) => tag.label.toLowerCase().includes(searchTerm)));
  };

  return (
    <DrawerComponent open={isOpen} onClose={onClose} styleVariant={"attribute"} customClassName="sidebar-drawer-main tag-drawer">
      <DrawerContainer className="main-drawer-container attribute-drawer">
        <DrawerHeader className="drawer-header-top">
          <LabelText className="drawer-title">Select desired tags</LabelText>
          <div className="header-buttons">
            <ForawrdBackwardButton onClick={onClose}>
              <CloseIcon className="cta-btn-icons" />
            </ForawrdBackwardButton>
          </div>
        </DrawerHeader>
        <div className="select-tags-content">
          <SearchTag className="search-tag">
            <SearchInput
              handleSearch={handleSearch}
              handleClear={handleClear}
              placeholder="Search tags"
              fontSize="32px"
              type="SearchPlayer"
              clearInput={clearInput}
              autoFocus={false}
            />
          </SearchTag>
          <div className="select-tag-list">
            {tagsState.map((tag) => (
              <TagsList key={tag.id} checked={tag.checked} className="tag-item">
                <CheckboxInput checked={tag.checked} className="attribute-checkbox-input">
                  <input type="checkbox" checked={tag.checked} onChange={() => handleCheckboxChange(tag.id)} className="checkbox" />
                  <span className={`label-text`}>{tag.label}</span>
                </CheckboxInput>
                <InfoOutlinedIcon className="cta-btn-icons" />
              </TagsList>
            ))}
          </div>
        </div>
        {anyTagChecked && (
          <SearchResults className="confirm-tag-btn">
            <PrimaryButton onClick={handleConfirm} iconType="confirm" label="Confirm" />
          </SearchResults>
        )}
      </DrawerContainer>
    </DrawerComponent>
  );
};

export default SelectTags;
